import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { getAllPayments } from '../../actions/payment';
import AdminPaymentItem from './AdminPaymentItem';

const AdminPaymentMain = ({ getAllPayments, auth, payment: {receipt}}) => {

    useEffect(() => {
        getAllPayments()
    }, [getAllPayments])

  return (
    <div className='container'>
        <h4><i className='fa-light fa-indian-rupee' style={{color: 'var(--primary-color)'}} />&nbsp;All Payments</h4>
        <Row xs={1} md={3} className="g-4">
            {receipt.map(payment => (
                <AdminPaymentItem key={payment._id} payment={payment} />
            ))}
        </Row>
    </div>
  )
}

AdminPaymentMain.propTypes = {
    getAllPayments: propTypes.func.isRequired,
    payment: propTypes.object.isRequired,
    auth: propTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    payment: state.payment
})

export default connect(mapStateToProps, {getAllPayments})(AdminPaymentMain);